import React, { Component } from "react";
import {Link} from "react-router-dom";
import './Attachment.scss';

import MyContext from '../MyContext.jsx';
import InfiniteScroll from "react-infinite-scroll-component";


class Attachment extends Component {
  url1 = `${process.env.REACT_APP_SSS}/`;

  constructor(props) {
    super(props);

    this.state = {
      catalogues : [],
    }
    this.getCatalogues = this.getCatalogues.bind(this);
  }

  componentDidMount(){  
    this.getCatalogues();
  }
  getCatalogues = () => {
    const url = `${process.env.REACT_APP_SSS}/api/getCatalogueAttachmentFiles`;
    this.context.loading(1);
    var obj_this = this;
    $.ajax({
      url : url,
      data : {
        sid : this.context.user_details.sid
      },
      type : "POST"
    }).done(function(return_data){
      console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          catalogues: return_data.catalogues,
        })
        obj_this.context.loading(0);
      }else{
        obj_this.context.loading(0);
        obj_this.props.history.replace("/");
      }
    }).fail(function(){
      alert("Network error");
    });
  }

  render(){

  return (

    <MyContext.Consumer>
      {context => (
       
        <div className="attachment_page_container">
        <div className="header_spacer"></div>
            <div className="attachment_container">
              <div className="page_header">
                <div className="page_title"><i className="fas fa-arrow-left" onClick={() => window.history.back()} style={{ marginRight: '15px', cursor: 'pointer' }}></i> Catalogue</div>
              </div>

              <div className="list_blocks_container">
                <InfiniteScroll
                  dataLength={this.state.catalogues.length || 1}
                  refreshFunction={this.getCatalogues}
                  pullDownToRefresh
                  pullDownToRefreshThreshold={200}
                  pullDownToRefreshContent={
                    <h3 style={{ textAlign: 'center', top: '50px' }}>&#8595; Pull down to refresh</h3>
                  }
                  releaseToRefreshContent={
                    <div className="loading_container" style={{ textAlign: 'center', top: '100px' }} >
                      <div className="loading_symbol">
                        <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                          width="40px" height="40px" viewBox="0 0 50 50" style={{ enableBackground: 'new 0 0 50 50' }}>
                          <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                          </path>
                        </svg>
                      </div>
                    </div>
                  }
                >
                  <div className="lists_container">
                    {this.state.catalogues.length === 0 ? (
                      <div className="no_result_msg">No catalogues available!</div>
                    ) : (
                      this.state.catalogues.map((item, index) => (
                        <div className="catalogue_card" key={index}>
                          <div className="catalogue_info">
                            <div className="catalogue_no">{index + 1}</div>
                            <div className="catalogue_name">{item.name}</div>
                          </div>
                          <div className="catalogue_action">
                            <span className="asm_download_button" onClick={(e) => {
                              e.stopPropagation();
                              var apk_url = this.url1 + item.file_path;
                              const cb = new Date().getTime();
                              const finalUrl = apk_url.includes('?') ? `${apk_url}&cb=${cb}` : `${apk_url}?cb=${cb}`;
                              if (typeof window !== 'undefined' && window.cordova && typeof cordova !== 'undefined' && cordova.InAppBrowser) {
                                cordova.InAppBrowser.open(finalUrl, '_system');
                              } else {
                                window.open(encodeURI(finalUrl), '_blank');
                              }
                            }}>
                              <i className="fa fa-download" ></i>&nbsp;View
                            </span>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </InfiniteScroll>
              </div>
            </div>
            {/** bottom spacer removed; global app_content adds bottom padding **/}
        </div>
        
      )}
    </MyContext.Consumer>
  )}
}

export default Attachment;
Attachment.contextType = MyContext;
